import { Box } from '@osmosis/react-ui/components/Box';
import { Button } from '@osmosis/react-ui/components/Button';
import { Flex } from '@osmosis/react-ui/components/Box';
import React from 'react';
import { useIntl, IntlShape } from 'react-intl';
import { billingTitles } from '../../constants/formatMesage';

type Props = {
  activePlanLength: number;
  setActivePlanLength: (tab: number) => void;
  planLengths: number[];
};

type PlanLengthOption = {
  id: number;
  title: string;
  discount: null | number;
};

function getTitle(intervalLength: number, intl: IntlShape) {
  if (intervalLength === 1) {
    return intl.formatMessage(billingTitles.monthlyShort);
  }

  if (intervalLength === 12) {
    return intl.formatMessage(billingTitles.yearlyShort);
  }

  if (intervalLength % 12 === 0) {
    const years = intervalLength / 12;

    return intl.formatMessage(billingTitles.multipleYearsShort, {
      count: years,
    });
  }

  return intl.formatMessage(billingTitles.multipleMonthsShort, {
    count: intervalLength,
  });
}

/**
 * Return Matrix Plans Tabs component.
 */
const MatrixPlanLinks = (props: Props) => {
  const { planLengths, activePlanLength, setActivePlanLength } = props;
  const intl = useIntl();

  const tabs = planLengths.map((planLength) => {
    return {
      id: planLength,
      title: getTitle(planLength, intl),
      discount: null,
    };
  });

  const handleTabClick = (index: number) => {
    setActivePlanLength(index);
  };

  const isActive = (tabId: number) => activePlanLength === tabId;

  return (
    <Flex height={30} width="100%" marginTop="4" marginBottom={4}>
      {tabs.map((tab: PlanLengthOption, index) => (
        <Flex key={tab.id} flexDirection="row">
          <Flex flexDirection={'column'} alignItems={'center'}>
            <Button
              bg={'transparent'}
              data-testid={`matrix-plan-length-${tab.id}`}
              color={isActive(tab.id) ? 'blue' : 'black'}
              onClick={() => handleTabClick(tab.id)}
              padding={'2px 12px 0px 12px'}
            >
              {tab.title.toUpperCase()}
            </Button>
            <Box
              bg={isActive(tab.id) ? 'blue' : 'transparent'}
              width={'80%'}
              height={'2.5px'}
              sx={{
                borderRadius: '3px',
              }}
            ></Box>
          </Flex>
          {index < tabs.length - 1 && (
            <Box
              width={'2px'}
              height={16}
              bg={'black'}
              style={{
                borderRadius: '3px',
              }}
              mt={'6px'}
            ></Box>
          )}
        </Flex>
      ))}
    </Flex>
  );
};

export default MatrixPlanLinks;
